const contact = {
  contact: {
    hero: {
      title: 'Contact Safaqat 24',
      subtitle: 'Our team is ready to help with all your real estate inquiries.',
    },
    intro: {
      title: 'Choose how you want to connect',
      description: 'We are here to help. Reach us by phone or email.',
    },
    channels: {
      title: 'Get in touch',
      description: 'Choose the method that works best for you.',
      items: [
        {
          icon: 'ri-phone-line',
          title: 'Call or WhatsApp',
          subtitle: '+966 50 560 8271',
          details: [
            'Available daily from 9:00 AM to 6:00 PM',
            'Property availability inquiries',
            'Help finding the right property',
            'Platform technical support',
          ],
        },
        {
          icon: 'ri-mail-line',
          title: 'Email',
          subtitle: 'info@safaqat24.sa',
          details: [
            'We reply within 1 to 5 working days',
            'Send detailed inquiries',
            'Partnership and collaboration requests',
            'Technical support and assistance',
          ],
        },
      ],
    },
    newsletter: {
      title: 'Stay updated with latest properties',
      subtitle: 'Subscribe to receive the latest property listings and updates.',
      interestLabel: 'Topics you care about',
      interestHelper: 'Select all that apply',
      interests: [
        'Villas for sale',
        'Apartments for rent',
        'Commercial properties',
        'Land for sale',
        'Market updates',
        'New listings',
      ],
      fields: {
        emailLabel: 'Email address *',
        emailPlaceholder: 'you@company.com',
        firstNameLabel: 'First name',
        firstNamePlaceholder: 'Mohammed',
      },
      submitLabel: 'Subscribe now',
      submitting: 'Subscribing...',
      success: 'You are subscribed! Expect updates soon.',
      error: 'We could not complete your subscription. Please try again.',
    },
    form: {
      title: 'Send us a message',
      subtitle: 'Share your details and we will get back to you as soon as possible.',
      replyTime: 'We will be in touch within 1 to 5 working days.',
      success: 'Thank you! Your message has been received.',
      error: 'We could not send your message. Please try again.',
      fields: {
        nameLabel: 'Full name *',
        namePlaceholder: 'Mohammed Al-Ali',
        emailLabel: 'Email address *',
        emailPlaceholder: 'you@company.com',
        phoneLabel: 'Phone number',
        phonePlaceholder: '+966 55 123 4567',
        subjectLabel: 'Reason for reaching out *',
        subjectOptions: [
          { value: '', label: 'Select a topic' },
          { value: 'property-inquiry', label: 'Property enquiry' },
          { value: 'general-question', label: 'General question' },
          { value: 'technical-support', label: 'Technical support' },
          { value: 'partnership', label: 'Partnership opportunity' },
          { value: 'other', label: 'Other' },
        ],
        messageLabel: 'How can we help? *',
        messagePlaceholder: 'Type your message here...',
        messageCounter: '{{count}}/500 characters',
      },
      submitLabel: 'Send message',
      submitting: 'Sending...',
    },
    consultation: {
      title: 'Need help finding a property?',
      description: 'Let us help you find the right property for your needs.',
      button: 'Start your search',
    },
    alerts: {
      contactSuccess: 'Thank you! Your message has been sent successfully. We will be in touch within 1 to 5 working days.',
      contactError: 'We could not send your message. Please try again.',
      newsletterSuccess: 'You are now subscribed successfully.',
      newsletterError: 'Something went wrong. Please try again.',
    },
  },
};

export default contact;
